import cn from 'classnames'
import { usePortalDropdown } from '@hooks/useDropdown'
import { DragIndicatorIcon } from '@components/icons/DragIndicatorIcon'
import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { DropdownSelectOptionType, DropdownSelectProps } from './interface'

export function DropdownSelect({
  options,
  className,
  handleSelect,
}: DropdownSelectProps) {
  const { Dropdown, isShowDropdown, toggleDropdown } = usePortalDropdown()
  const { isNightOrDarkTheme } = useTheme()
  return (
    <div className={cn('relative', className, { hidden: !options.length })}>
      <button type='button' onClick={toggleDropdown}>
        <DragIndicatorIcon
          width='18'
          height='18'
          className={cn(
            { 'text-primary': isShowDropdown },
            { 'text-secondary-1 dark:text-white': !isShowDropdown }
          )}
        />
      </button>
      <Dropdown zIndex={100}>
        <div
          className={cn(
            'w-[150px] text-[14px] text-secondary bg-white border border-gray rounded-[10px] max-h-[400px] overflow-y-auto shadow',
            {
              hidden: !isShowDropdown,
              'border-dark-8 bg-dark-8 text-dark-10': isNightOrDarkTheme,
            }
          )}
        >
          {options.map((row: DropdownSelectOptionType, index: number) => (
            <div
              className={cn(
                'flex items-center py-[10px] px-[10px] space-x-[10px] font-light cursor-pointer text-[14px] text-gray-7 hover:bg-blue-2 hover:text-primary',
                {
                  'bg-dark-8 hover:bg-dark text-dark-10': isNightOrDarkTheme,
                }
              )}
              key={index}
              onClick={() => handleSelect(row.value)}
            >
              {row.label}
            </div>
          ))}
        </div>
      </Dropdown>
    </div>
  )
}
